module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-LUXURY-SUPERIOR-SEA-VIEW-ROOM.36ec4ade.jpg";